var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1695_955)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5733 7.65158L12.8942 7.6209C12.5414 7.6209 12.2526 7.90465 12.2526 8.25742C12.2526 8.61019 12.5363 8.89905 12.8891 8.89905L19.0344 8.92462L7.93497 20.0241C7.68446 20.2746 7.68445 20.6785 7.93497 20.929C8.18549 21.1795 8.58939 21.1795 8.8399 20.929L19.9394 9.82955L19.9649 15.9749C19.9649 16.3277 20.2538 16.6114 20.6066 16.6114C20.9593 16.6114 21.2431 16.3226 21.2431 15.9698L21.2124 8.29065C21.2099 7.94044 20.9236 7.65413 20.5733 7.65158Z",
    fill: "#292929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1695_955"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.5096,
    height: 18.5096,
    fill: "white",
    transform: "translate(0.482788 13.4828) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowLogo);
export default __webpack_public_path__ + "static/media/right-arrow-logo.a7290dafe55b90106749fd0e3c20b038.svg";
export { ForwardRef as ReactComponent };